<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration" />
    <dv-decoration-8 class="header-right-decoration" :reverse="true" />
    <div class="center-title" v-on:click="Ment">延锋能源信息中心</div>
    <div class="me" v-show="show1==true">
      <TopMenu />
    </div>
  </div>
</template>

<script>
import TopMenu from '../TopMenu/index';
export default {
  name: 'TopHeader',
  components: {
    TopMenu
  },
  data() {
    return {
      show1: false
    };
  },
  methods: {
    Ment() {
      if (this.show1 === false) {
        this.show1 = true;
      } else {
        this.show1 = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
#top-header {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  background-color: #253e5d;

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 30px;
  }

  .header-left-decoration,
  .header-right-decoration {
    width: 25%;
    height: 60px;
  }

  .center-title {
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    left: 50%;
    top: 20px;
    transform: translateX(-50%);
  }
  .me {
    z-index: 999;
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    /* height: 1090px; */
    flex-shrink: 0;
    float: left;
  }
}
</style>
